module.exports = __webpack_public_path__ + "static/img/bridge.191445d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/media/bridge.jpg
// module id = +dFO
// module chunks = 0